import { Application } from "@hotwired/stimulus"

const application = Application.start()

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

// Register controllers from tailwindcss-stimulus-components
import { Alert, Popover, Toggle } from "tailwindcss-stimulus-components"
application.register("alert", Alert)
application.register("popover", Popover)
application.register("toggle", Toggle)

// Register controllers from @stimulus-components/checkbox-select-all
import CheckboxSelectAll from "@stimulus-components/checkbox-select-all"
application.register("checkbox-select-all", CheckboxSelectAll)

export { application }
